import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { Helmet } from 'react-helmet-async'

import CustomPaper from '@/components/custom-paper'
import EkokomBonusTabs from '@/components/ekokom-bonus/tabs'

function EkokomBonusView() {

    const title = 'Nastavení EKOKOM bonusu'

    return (
        <>
            <Helmet>
                <title>{title}</title>
            </Helmet>
            <CustomPaper noPadding>
                <Box p={2.5}>
                    <Typography variant="h2" component="h1">
                        {title}
                    </Typography>
                </Box>
                <EkokomBonusTabs />
            </CustomPaper>
        </>
    )
}

export default EkokomBonusView
